import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useEffectOnce } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import {
  UserVehicleContext,
  useVehicleAvailability
} from '~/context/vdp/UserVehicleContext';

export default function useSendAvailabilityData() {
  const { trackEvent } = useContext(AnalyticsContext);
  const {
    vehicleAvailability: { isLoaded }
  } = useContext(UserVehicleContext);
  const { action, error, lockType } = useVehicleAvailability();

  useEffectOnce(
    () => {
      trackEvent('Availability data', { action, error, lockType });
    },
    [action, error, lockType, trackEvent],
    isLoaded
  );
}
